import { Link, Tooltip, useTheme } from "@mui/material";

import { useTenantTranslation } from "hooks/formatters";
import { useNumberSerialiser } from "hooks/serialisers/numbers";

import { MixDetailsPanel } from "../mixDetails/MixDetailsPanel";
import { usePlanId } from "../../boundary/PlanId";
import { usePeriodIndex } from "hooks/periodIndex";
import { useNumberQueryParamState } from "hooks/useNumberQueryParamState";

interface Props {
  name: string;
  multipleMixes: boolean;
  mix: number;
  group: number;
}

export const ChemistryGroupCell = ({
  name,
  multipleMixes,
  mix,
  group,
}: Props) => {
  const theme = useTheme();
  const planId = usePlanId();
  const period = usePeriodIndex();

  const { t } = useTenantTranslation();
  const { format } = useNumberSerialiser();

  const [showPanel, setShowPanel] = useNumberQueryParamState(
    "selected_mix_id",
    null
  );

  const title = `${name} ${
    multipleMixes ? ` (${t("mix")} ${format(mix)})` : ""
  }`;

  return (
    <>
      <Tooltip title={title}>
        <Link
          variant="body2"
          color={theme.palette.text.primary}
          fontWeight="fontWeightBold"
          sx={{ cursor: "pointer" }}
          onClick={() => {
            setShowPanel(group);
          }}
        >
          {title}
        </Link>
      </Tooltip>
      <MixDetailsPanel
        group={group}
        open={showPanel === group}
        setOpen={(open) => {
          setShowPanel(open ? group : null);
        }}
        mix={mix}
        planId={planId}
        period={period}
        multipleMixes={multipleMixes}
      />
    </>
  );
};
